import * as api from "../constants/api";
import axios from "../services/axios";
import * as handle from "../utils/actionUtils";
// import * as apiResponseUtils from "../utils/apiResponseUtils";
import { toIsoString } from "../utils/date";
import { setTotal as setTotalAction } from "./advancedListActions";

export const GET_ETTERSENDELSER_SUCCESS = "GET_ETTERSENDELSER_SUCCESS";
const GET_ETTERSENDELSER_FAILURE = "GET_ETTERSENDELSER_FAILURE";

export function getEttersendelser(params, page, count) {
  return async (dispatch) => {
    dispatch(setTotalAction("ettersendelser", 1)); // WTF?? Does this work when pagination is used?
    return axios
      .get(api.GET_ILEGGELSER_URL, {
        params: {
          ...params,
          fraDato: params.fraDato && toIsoString(params.fraDato),
          tilDato: params.tilDato && toIsoString(params.tilDato),
          orderBy: "ascending",
          page: page,
          pageSize: count,
        },
        paramsSerializer: {
          indexes: null,
        },
      })
      .then((response) => {
        dispatch(
          setTotalAction(
            "ettersendelser",
            JSON.parse(response.headers["x-pagination"]).Total,
          ),
        );
        dispatch({
          type: GET_ETTERSENDELSER_SUCCESS,
          payload: response.data.result,
        });
        return Promise.resolve(response);
      })
      .catch((error) => {
        handle.error(dispatch, GET_ETTERSENDELSER_FAILURE);
        return Promise.reject(error);
      });
  };
}

export function putIleggelseEttersendelserTilGodkjenning(
  ileggelseEttersendelseId,
  data,
) {
  let putApi = api.PUT_ILEGGELSE_ETTERSENDELSER_TIL_GODKJENNING(
    ileggelseEttersendelseId,
  );
  return async () => {
    return axios
      .put(putApi, data)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  };
}
